<script>
import BaseDrawer from '@/components/BaseDrawer.vue';

/**
 * То же, что PopupWrapper, но открывает *DrawerWrappable в боковой шторке.
 * Контракт с PopupDispatcher общий: open(wrappable) возвращает промис,
 * который разрешается результатом close().
 */
export default {
  name: 'DrawerWrapper',
  components: { BaseDrawer },
  controller: null,
  data() {
    return {
      isOpened: false,
      wrappable: null,
      drawerOptions: {},
    };
  },
  computed: {
    props() { return this.wrappable?.props ?? {}; },
  },
  methods: {
    open(wrappable) {
      this.wrappable = wrappable;
      this.drawerOptions = wrappable.options ?? {};
      this.isOpened = true;

      this.$nextTick(() => {
        const params = wrappable.params ?? {};
        this.$refs.wrappable.init?.(params); // eslint-disable-line
      });

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(result) {
      this.isOpened = false;
      this.$options.controller.resolve(result);
    },
  },
};
</script>

<template lang="pug">
  BaseDrawer(@close="close(false)" v-if="isOpened" v-bind="drawerOptions")
    component(:is="wrappable.component" v-bind="props" @finish="close" ref="wrappable")
</template>

<style scoped lang="scss">

</style>
